import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const clearState = createAction(ACTION.CLEAR_STATE);
export const fetchSetting = createAction(ACTION.FETCH_SETTING.REQUEST);